// extracted by mini-css-extract-plugin
export var dropdownButton = "_34-0";
export var fullWidthDropdownButton = "_34-1";
export var icon = "_34-3";
export var iconPlaceholder = "_34-2";
export var shortcutContainer = "_34-4";